import React from 'react';

import {isAdminPage, roundedElements} from 'Services/BaseHelpers';

import Base from './Base';

/**
 * @function PrimaryButton
 * @param {function} onClick
 * @param {string} className
 * @param {string} text
 * @param {boolean} working
 * @param {boolean} disabled
 * @param {string} [type]
 * @return {JSX.Element}
 * @constructor
 */
const DarkButton = ({ onClick, className, text, working, disabled, type }) => {
    let classes = `
        ${isAdminPage() ? 'bg-blue-700 text-white text-sm font-medium' : 'bg-app-blue text-white transition duration-200  text-lg'}
        ${roundedElements() ? '' : ''}
        border border-transparent shadow-sm py-2 px-12
        inline-flex justify-center items-center
        ${
            !disabled && !working
                ? `
                    ${isAdminPage() ?
                        'hover:bg-light-blue-800 focus:ring-light-blue-500' :
                        'hover:bg-white hover:border-app-blue hover:border hover:text-app-blue focus:ring-app-primary-focus'}
                    focus:outline-none focus:ring-2 focus:ring-offset-2
                `
                : 'opacity-50'
        }
        ${className}
    `;

    if (!isAdminPage()) {
        // overwrite classes as required for non-admin pages.
    }

    return (
        <Base
            className={classes}
            type={type ?? (onClick !== undefined ? 'button' : 'submit')}
            onClick={onClick}
            disabled={disabled}
            working={working}
            text={text}
        />
    );
};

export default DarkButton;
